/*** TIME ***/

export default class Time {
    constructor() { }

    // MILISECONDS TO STRING (mi:ss:ms)
    calculateTime(mlseconds: number): string {
        mlseconds = mlseconds < 0 ? 0 : mlseconds

        let mi = Math.floor(mlseconds / 1000 / 60);
        let ss = Math.floor((mlseconds / 1000) % 60);
        let ms = Math.floor(mlseconds % 1000);

        const fillZero = (time: number): string => {
            return time < 10 ? `0${time}` : `${time}`;
        };

        return `${fillZero(mi)}M:${fillZero(ss)}S:${fillZero(ms)}MS`;
    }

    // SECONDS TO MILISECONDS
    secToMilisec(value: number): number {
        return value * 1000;
    }

    // MILISECONDS TO SECONDS
    milisecToSec(value: number): number {
        return value * 0.001;
    }
}